<template>
<transition name="slide">
  <div class="container-fluid">
    <div class="row mt17">
      <div class="col-lg-2 col-md-6 col-sm-6">
        <square-card :backgroundImg="getLoggedRoleImg(loggedRole)" :gradient="gradientSwitcher(loggedRole.type)">
          <div slot="header" class="square-content flex-center">
          </div>
          <div slot="content">
            <h2 class="title">{{$t('roles.'+loggedRole.type)}}</h2>
            <p class="label" :title="getLoggedRoleName(loggedRole)">{{getLoggedRoleName(loggedRole)}}</p>
            <div class="text-center">
              <donapp-button v-if="loggedRole.type!='user'" :text="$t('labels.back')" :class="['btn', gradientSwitcher(loggedRole.type) ]" :action="back" />
              <donapp-button v-if="loggedRole.type=='user'" :text="$t('labels.go_to_app')" :class="['btn', gradientSwitcher(loggedRole.type) ]" :value="loggedRole._id" :action="goToDownloadAppPage" />
            </div>
          </div>
        </square-card>
      </div>
      <div v-if="loading" class="col-lg-2 col-md-6 col-sm-6 loading flex-center">
        <svg class="circle-loader" width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="15" />
        </svg>
      </div>
      <div v-if="roles.length > 0" v-for="(role, index) of roles" :key="index" class="col-lg-2 col-md-6 col-sm-6">
        <square-card :backgroundImg="getLoggedRoleImg(role)" :gradient="gradientSwitcher(role.type)">
          <div slot="header" class="square-content flex-center">
          </div>
          <div slot="content">
            <h4 class="title">{{$t('roles.'+role.type)}}</h4>
            <p class="label" :title="getLoggedRoleName(role)">{{getLoggedRoleName(role)}}</p>
            <div class="text-center">
              <donapp-button v-if="role.type!='user'" :text="$t('labels.change_role')" :class="['btn', gradientSwitcher(role.type) ]" :value="role._id" :action="changeRole" />
              <donapp-button v-if="role.type=='user'" :text="$t('labels.go_to_app')" :class="['btn', gradientSwitcher(role.type) ]" :value="role._id" :action="goToDownloadAppPage" />
            </div>
          </div>
        </square-card>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import SquareCard from '@/components/shared/SquareCard'
import DonappButton from '@/components/shared/buttons/Button'
import gradientSwitcher from '@/mixins/GradientSwitcher'
import apiService from '@/services/ApiService'

export default {
  name: 'change-role',
  components: {
    SquareCard,
    DonappButton
  },
  mixins: [gradientSwitcher],
  data() {
    return {
      loading: true,
      roles: []
    }
  },
  mounted: async function() {
    this.loading = true
    try {
      const result = await apiService.getRoles()
      this.roles = result.data.data.roles.filter(
        role => role.type !== 'user' && this.loggedRole._id !== role._id && role[role.type]
      )
      if (this.loggedRole.type !== 'user') this.roles.push({ ...this.user, type: 'user' })
    } catch (error) {
      this.$toasted.error(this.$i18n.t('errors.something_wrong') + ': ' + error.message)
    }

    this.loading = false
  },
  methods: {
    ...mapMutations({
      goTo: 'goTo'
    }),
    ...mapActions({
      changeRole: 'changeRole'
    }),
    capitalize: type => type[0].toUpperCase() + type.substring(1),
    back: function() {
      let name = 'ChangeRole'
      if (this.loggedRole.type === 'merchant') name = 'MerchantDashboard'
      else if (this.loggedRole.type === 'npo') name = 'NpoDashboard'
      this.goTo({ name })
    },
    getLoggedRoleName: function(role) {
      switch (role.type) {
        case 'merchant':
          return role.merchant.name
        case 'npo':
          return role.npo.name
        case 'user':
          return this.user.name || this.user.email
        default:
          break
      }
    },
    getLoggedRoleImg: function(role) {
      switch (role.type) {
        case 'merchant':
          return role.merchant.img || './static/img/shop.svg'
        case 'npo':
          return role.npo.img || './static/img/npo.svg'
        case 'user':
          return this.user.img || './static/img/profile_icon.svg'
        default:
          break
      }
    },
    goToDownloadAppPage: function() {
      window.open('https://www.donapp.it', '_blank')
    }
  },
  computed: {
    ...mapState({
      loggedRole: state => state.user.loggedRole,
      user: state => state.user
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/config.scss';
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

.label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.square-content {
  opacity: 0.75;
}

.loading {
  height: 348px;
}

.circle-loader {
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ChangeRole.vue